import * as z from "zod/v4";

export const cancelWorkOrder = {
  name: "cancelWorkOrder" as const,
  input: z.object({ workOrderId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
